import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Home.css";
import imgLogo from "../assets/imglogo.png";
import nameLogo from "../assets/name.png";

export default function Home() {
  const { t } = useTranslation("home");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(id);
  }, []);

  return (
    <main className={`cm-home ${visible ? "cm-home--in" : ""}`}>

      <div className="cm-grain" aria-hidden="true" />

      <div className="cm-crescent" aria-hidden="true">
        <img src={imgLogo} alt="" className="cm-crescent__logo" />
      </div>

      <section className="cm-hero">

        <div className="cm-hero__meta cm-reveal" style={{ "--d": "0ms" }}>
          <div className="cm-badge">
            <span className="cm-badge__dot" />
            {t("badge")}
          </div>
        </div>

        <img
          src={nameLogo}
          alt="Connect Moon"
          className="cm-hero__logo cm-reveal"
          style={{ "--d": "100ms" }}
        />

        <p className="cm-desc cm-reveal" style={{ "--d": "220ms" }}>
          {t("desc")}
        </p>

        <div className="cm-ctas cm-reveal" style={{ "--d": "340ms" }}>
          <a href="/contactos" className="cm-btn cm-btn--primary">
            <span className="cm-btn__text">{t("cta1")}</span>
            <span className="cm-btn__arrow">→</span>
          </a>
          <a href="/#servicos" className="cm-btn cm-btn--ghost">
            {t("cta2")}
          </a>
        </div>

      </section>

      <div className="cm-strip cm-strip--dark cm-strip--solo" aria-hidden="true">
        <div className="cm-strip__track cm-strip__track--reverse">
          {[...Array(12)].map((_, i) => (
            <span key={i} className="cm-strip__item cm-strip__item--dark">
              <img src="/logo.jpeg" alt="" className="cm-strip__logo" />
            </span>
          ))}
        </div>
      </div>

    </main>
  );
}
